import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {BinKeysService} from '../../services/bin-keys.service';
import {OverlayPanel} from 'primeng/overlaypanel';
import {BaseClientComponent} from '../base-client.component';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {TechnicalPopService} from '../../services/technical-pop.service';

@Component({
  selector: 'app-admin-encryption-keys',
  templateUrl: './admin-encryption-keys.component.html',
  styleUrls: ['./admin-encryption-keys.component.scss']
})
export class AdminEncryptionKeysComponent extends BaseClientComponent implements OnInit {
  availableKeys = false;
  keysInformation = [];
  pops = [];
  numberOfProdKeys: string;
  numberOfUatKeys: string;
  channelSelected: string;
  popSelected: string;
  loading = true;
  loadError = false;
  weekDisplayed: string;

  constructor(public authenticationService: AuthenticationService,
              protected technicalPopService: TechnicalPopService,
              public binKeysService: BinKeysService,
              private utilsService: UtilsService) {
    super();
  }

  ngOnInit() {
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.getKeysInformation();
    });
    this.subscriptions.push(response$);
  }

  private getKeysInformation() {
    this.binKeysService.getKeysInformation().subscribe({
        next: binKeysInformation => {
          if (binKeysInformation.length !== 0) {
            this.pops = binKeysInformation['pops'];
            this.formattedData(binKeysInformation['formattedData']);
            this.weekDisplayed = binKeysInformation['date'];
            this.availableKeys = true;
          }
          this.loading = false;
        }, error: () => {
          this.loading = false;
          this.loadError = true;
          this.utilsService.displayMessage('The encryption keys could not be loaded', 'Please try again later.', 'error');
        }
      }
    );
  }

  private formattedData(binKeysInformation: any) {
    for (const element in binKeysInformation) {
      this.keysInformation.push({
        channel: element,
        pops: binKeysInformation[element]
      });
    }
  }

  displayItem(event, keyInformation, pop, overlayPanel: OverlayPanel) {
    this.channelSelected = keyInformation['channel'];
    this.popSelected = pop;
    const counts = keyInformation['pops'][pop] ?? {};
    this.numberOfProdKeys = counts.prod ?? 0;
    this.numberOfUatKeys = counts.uat ?? 0;
    overlayPanel.toggle(event);
  }
}
